/* istanbul ignore next */

/* istanbul ignore file */
export const modalNotificationTheme = (baseTheme) => ({
  backgroundOpacity: 0.3,
  borderColor: '#FFF',
  // TODO: use light blue from api/theme/theme bottomline blue somehow
  borderLeft: `${4}px solid ${baseTheme.palette.primary.light}`,

  borderLeftWidth: 4,

  borderRadius: 0,
  crossIconRoundedColor: '#4c4c4c',
  headerBackground: '#FFF',
  iconColor: '#ccc',
  spacing: 8,
  width: 500
});

export default ({
  modalNotification: {
    backgroundOpacity,
    borderColor,
    borderLeft,
    borderLeftWidth,
    borderRadius,
    crossIconRoundedColor,
    headerBackground,
    iconColor,
    spacing,
    width,
    zIndex
  },
  palette: {
    error,
    info,
    success,
    text: { dark: textColor },
    warning
  },
  spacing: { unit },
  transitions: {
    duration: { short }
  },
  typography: { headline2 }
}) => ({
  backdrop: {
    backgroundColor: `rgba(0, 0, 0, ${backgroundOpacity})`,
    bottom: 0,
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: 0
  },
  content: {
    backgroundClip: 'padding-box',
    backgroundColor: '#fff',
    '&:before': {
      borderLeft,
      content: '""',
      height: 'calc(100% + 2px)',
      left: -1 - borderLeftWidth,
      position: 'absolute',
      top: -1
    },
    border: `1px solid ${borderColor}`,
    borderRadius,
    position: 'relative',

    textAlign: 'center'
  },
  dialog: {
    color: textColor,
    left: 34,
    display: 'flex',
    margin: `${spacing * 2}px auto`,
    flexDirection: 'column',
    maxWidth: width,
    '&.emulation': {
      left: 0,
      margin: 'auto',
      width: '95%'
    },
    position: 'relative',
    height: '100%',
    width: '80%',
    justifyContent: 'center',

    zIndex: 1
  },

  error: {
    '&:before': {
      borderLeftColor: error.lightOrange
    }
  },

  header: {
    backgroundColor: headerBackground,
    border: '0',
    borderRadius: `${borderRadius}px ${borderRadius}px 0 0`,
    overflow: 'auto',
    padding: `${spacing * 1.5}px ${spacing * 2}px`
  },

  checkmarkWrapper: {
    '& svg': {
      height: spacing * 6,
      width: spacing * 6,
      fill: iconColor
    },
    marginBottom: unit
  },

  headerCloseBth: {
    color: textColor,
    fontSize: `${spacing * 2.6}px !important`,
    fontWeight: 'bold',
    margin: 0,
    opacity: '0.2',
    '&:active': {
      boxShadow: 'none'
    },
    position: 'absolute',
    padding: 0,
    right: `${spacing * 2}px`,
    top: `${spacing * 1.5}px`
  },

  closeRounded: {
    cursor: 'pointer',
    opacity: 1,
    margin: 0,
    position: 'absolute',
    '&:active': {
      boxShadow: 'none'
    },
    right: `${spacing * 3}px`,
    '& svg': {
      fill: crossIconRoundedColor
    },
    top: `${spacing * 3}px`,
    padding: 0
  },

  modalBody: {
    '& .modal-header': {
      backgroundColor: '#fff',
      fontSize: headline2.fontSize,
      marginBottom: 3 * unit,
      overflow: 'visible',
      padding: 0,
      textTransform: 'uppercase'
    },
    padding: `${spacing * 3}px`,
    '& .modal-text': {
      marginBottom: 6 * unit
    }
  },
  info: {
    '&:before': {
      borderLeftColor: info.dark
    }
  },
  modalComponent: {},
  infoStatic: {
    '&:before': {
      // NOTE: for some reason info.normal color not working,
      borderLeftColor: '#00DFEB'
    }
  },
  root: {
    transition: `visibility ${short}s`,
    pointerEvents: 'none',
    visibility: 'hidden',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex
  },

  modalFooter: {
    border: 0,
    padding: '10px 20px 20px',
    textAlign: 'left'
  },

  modalIn: {
    display: 'block',
    overflowX: 'hidden',
    overflowY: 'hidden',
    pointerEvents: 'auto',
    transition: 'none',
    visibility: 'visible',
    zIndex: 100000
  },

  success: {
    '&:before': {
      borderLeftColor: success.dark
    }
  },

  warning: {
    '&:before': {
      borderLeftColor: warning.dark
    }
  }
});
